import {RsnButton, RsnDialog} from '@raison/ui-kit';
import React from 'react';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

export function WrongDateIntervalDialog({isOpen, onClose}: Props) {
    return (
        <RsnDialog.Controller isOpen={isOpen} onClose={onClose}>
            <RsnDialog.Window placement='bottom'>
                <RsnDialog.CenteredHeader icon={{element: <RsnDialog.StatusIcon status='alert' />}} />
                <RsnDialog.Body>
                    <div className='flex flex-col gap-4 text-center'>
                        <div className='fv-heading-m text-neutral-100'>Wrong date interval</div>
                        <div className='fv-text-l-regular text-neutral-90'>
                            Start date must be earlier or equal to end date.
                        </div>
                    </div>
                </RsnDialog.Body>
                <RsnDialog.Footer>
                    <RsnButton.Secondary onClick={onClose}>I got it</RsnButton.Secondary>
                </RsnDialog.Footer>
            </RsnDialog.Window>
        </RsnDialog.Controller>
    );
}
